import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import PlantSupply from "./pages/services/PlantSupply";
import PotsSupply from "./pages/services/PotsSupply";
import IndoorPlantSetup from "./pages/services/IndoorPlantSetup";
import KitchenGarden from "./pages/services/KitchenGarden";
import LandscapeMaintenance from "./pages/services/LandscapeMaintenance";
import ArtificialLawn from "./pages/services/ArtificialLawn";
import VerticalGarden from "./pages/services/VerticalGarden";
import DripIrrigation from "./pages/services/DripIrrigation";
import ScrollToTop from './components/ScrollToTop';
import Gallery from './pages/Gallery';


function App() {
  return (
    <Router>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/services/plant-supply" element={<PlantSupply />} />
        <Route path="/services/pots-supply" element={<PotsSupply />} />
        <Route path="/services/indoor-plant" element={<IndoorPlantSetup />} />
        <Route path="/services/kitchen-garden" element={<KitchenGarden />} />
        <Route path="/services/maintenance" element={<LandscapeMaintenance />} />
        <Route path="/services/artificial-lawn" element={<ArtificialLawn />} />
        <Route path="/services/vertical-garden" element={<VerticalGarden />} />
        <Route path="/services/drip-irrigation" element={<DripIrrigation />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
